import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import Card, { CardSection } from '@lightspeed/cirrus-card';
import Text from '@lightspeed/cirrus-text';
import Select from '@lightspeed/cirrus-select';

import Skeleton from './Skeleton';

const STRINGS = {
  DESCRIPTION: 'Gateway',
};

const GatewayType = ({ isLoading, gatewayTypes, fieldName, disabled }) => {
  const gatewayTypeOptions = gatewayTypes.map(gatewayType => (
    <option key={gatewayType.gatewayID} value={gatewayType.gatewayID}>
      {gatewayType.name}
    </option>
  ));

  return isLoading ? (
    <Skeleton />
  ) : (
    <Card>
      <CardSection noSpacing>
        <div className="cr-flex cr-justify-between cr-items-center cr-pl-3 cr-pr-4 cr-pt-4 cr-pb-4">
          <Text className="cr-flex cr-width-full cr-width-6-12-lg" bodySmall bold>
            {STRINGS.DESCRIPTION}
          </Text>
          <div className="cr-flex cr-width-full cr-width-6-12-lg">
            <Field
              name={fieldName}
              render={({ field }) => (
                <Select {...field} disabled={disabled}>
                  {gatewayTypeOptions}
                </Select>
              )}
            />
          </div>
        </div>
      </CardSection>
    </Card>
  );
};

GatewayType.propTypes = {
  isLoading: PropTypes.bool,
  gatewayTypes: PropTypes.arrayOf(PropTypes.shape),
  fieldName: PropTypes.string,
  disabled: PropTypes.bool,
};

GatewayType.defaultProps = {
  isLoading: true,
  gatewayTypes: [],
  fieldName: 'gatewayID',
  disabled: false,
};

export default GatewayType;
